export default function NextStepsContent() {
  return (
    <div>
      <p className="mb-4">
        This Getting Started guide provides an overview of the core concepts and
        entities in the Justin Legal API. To begin integrating with the API,
        you'll want to:
      </p>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Decide whether your workflow uses anonymous intake endpoints, API key
          access, Bearer token access, or a combination of those modes.
        </li>
        <li>
          Obtain an API key for server or web integrations that need
          authenticated law firm access.
        </li>
        <li>
          Load the relevant Form and familiarize yourself with the CaseFile
          structure and operations.
        </li>
        <li>
          Explore how to work with related entities like Contacts,
          Relationships, and Insurances.
        </li>
      </ol>
      <p className="mt-4">
        For more detailed information on each endpoint, request and response
        formats, and advanced features, please refer to the specific API
        reference documentation.
      </p>
    </div>
  );
}
